import react, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";

import { Puff } from "react-loading-icons";
import { Grid } from "../../../../Layout/Grid/GridView";
import { Input } from "../../../../Layout/Forms/Form";
import PromotersListRequests from "../PromotersListRequests";
import { format, subDays } from "date-fns";
import NavBar from "../../../../../components/NavBar";

const PromoterStats = () => {
  const gridRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  let params = useParams();
  const currentDate = new Date();
  const dateMinus30Days = subDays(currentDate, 30);
  const formattedCurrentDate = format(currentDate, "yyyy-MM-dd");
  const formattedDateMinus30Days = format(dateMinus30Days, "yyyy-MM-dd");
  const [state, setState] = useState({
    form: {
      date_start: formattedDateMinus30Days,
      date_end: formattedCurrentDate,
    },
    list: [],
  });

  const handleChangeInputs = (e) => {
    if (!isLoading) {
      setState({
        ...state,
        form: {
          ...state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };

  const InsideLoading = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          <Puff stroke="#333" height="5em" width="5em" />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "100%",
          }}
        >
          Loading...
        </div>
      </div>
    );
  };

  const columns = ["Nome", "Nº Registos", "Nº Entradas", "Taxa Conversão"];

  const serializeRowsColums = (data) => {
    return data.map((item) => {
      return {
        ...item,
      };
    });
  };

  const handlerRequestList = async () => {
    setIsLoading(true);
    let info = await PromotersListRequests.getPromotersStats(state.form);
    if (info && info.status) {
      setState({
        ...state,
        list: info.data.list,
      });
    }
    setIsLoading(false);
  };

  useEffect(() => {
    console.log(state);
    document.title = "Promoters Stats | Nightspot Dashboard";
    handlerRequestList();
  }, []);

  useEffect(() => {
    handlerRequestList();
  }, [state.form.date_start, state.form.date_end]);

  return (
    <div>
      <NavBar>
        <div className="row">
          <div className="col-sm-12 dashboard-content">
            {isLoading ? (
              <InsideLoading />
            ) : (
              <>
                <div className="row">
                  <div className="col-12 col-sm-6">
                    <h2 className="dashboard-h2">Estatisticas Promotores</h2>
                  </div>

                </div>
                <div className="row">
                  <div className="col-6">
                    <nav>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to="/my/dashboard">
                            <i className="fa-solid fa-home"></i>
                          </Link>
                        </li>
                        <li className="breadcrumb-item">
                          <Link to="/my/promoters/">Lista Promotores</Link>
                        </li>
                        <li className="breadcrumb-item active">
                          Estatisticas Promotores
                        </li>
                      </ol>
                    </nav>
                  </div>
                  <div className="col-6 col-sm-3 ">
                    <Input
                      label="Data Inicio"
                      name="date_start"
                      value={state.form.date_start}
                      onChange={(e) => handleChangeInputs(e)}
                      onPaste={(e) => {
                        e.preventDefault();
                        handleChangeInputs({
                          target: {
                            name: e.target.name,
                            value: e.clipboardData.getData("Text"),
                          },
                        });
                      }}
                      type="date"
                      errors={state.errors}
                    />
                  </div>
                  <div className="col-6 col-sm-3 ">
                    <Input
                      label="Data Fim"
                      name="date_end"
                      value={state.form.date_end}
                      onChange={(e) => handleChangeInputs(e)}
                      onPaste={(e) => {
                        e.preventDefault();
                        handleChangeInputs({
                          target: {
                            name: e.target.name,
                            value: e.clipboardData.getData("Text"),
                          },
                        });
                      }}
                      type="date"
                      errors={state.errors}
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-12">
                    {/* <Table
                      columns={columns}
                      data={serializeRowsColums(state.list)}
                      currentPage={1}
                      itemsPerPage={20}
                      totalItems={state.list.length}
                    /> */}
                    <Grid
                      ref={gridRef}
                      rows={state.list}
                      cols={[
                        { hide: true, field: "id" },
                        { headerName: "Nome", field: "nome" },
                        { headerName: "Nº Entradas", field: "Nº Entradas" },
                        { headerName: "Nº Registos", field: "Nº Registos" },
                        { headerName: "Taxa Conversão", field: "Taxa Conversão" },
                      ]}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </NavBar>
    </div>
  );
};

export default PromoterStats;
